import { reducerRegistry } from '../../../../reducerRegistry';

import listsReducersMap from './lists/reducersMap';

const combineMap = {
  lists: listsReducersMap
};

export default function combineRegistry() {
  reducerRegistry.registerByCombineMap('userRatingModule', combineMap);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userRating/reducers/static/combineRegistry.js